import React, { useEffect } from "react";

import "./Opinie.css";

const Opinie = () => {
    useEffect(() => {
        const script = document.createElement("script");

        script.src = "https://apps.elfsight.com/p/platform.js";
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className="app__bg section__padding" id="opinie">
            <hr className="hr2" />

            <h1 className="h1_opinie">Opinie</h1>
            <div className=".app__laurels_awards ">
                <div class="elfsight-app-9d7ca725-4a04-4b6b-8ead-72e8b588495b"></div>
            </div>
        </div>
    );
};

export default Opinie;
